import React from 'react';
import { Button, Space } from 'antd';
import type { FormMode } from '../hooks/usePWP255Mode';

interface ActionBarProps {
  mode: FormMode;
  hasRecord: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  loading: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  onAdd: () => void;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode, hasRecord, hasPrev, hasNext, loading,
  onFirst, onPrev, onNext, onLast,
  onAdd, onEdit, onSave, onCancel,
}) => {
  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <div className="pwp255-action-bar">
      <Space wrap>
        {/* Navigation - only in view mode */}
        {!isEditing && (
          <>
            <Button size="small" onClick={onFirst} disabled={!hasPrev || loading}>首筆</Button>
            <Button size="small" onClick={onPrev} disabled={!hasPrev || loading}>上筆</Button>
            <Button size="small" onClick={onNext} disabled={!hasNext || loading}>下筆</Button>
            <Button size="small" onClick={onLast} disabled={!hasNext || loading}>末筆</Button>
          </>
        )}

        {/* Add button (browse mode only) - per BR-019, Add is disabled in browse mode;
            user must press Edit first. But we keep a standard "新增" for new records. */}
        {!isEditing && (
          <Button type="primary" size="small" onClick={onAdd} disabled={loading}>新增</Button>
        )}

        {/* Edit button (browse mode with record) */}
        {!isEditing && hasRecord && (
          <Button size="small" onClick={onEdit} disabled={loading}>修改</Button>
        )}

        {/* Save button (editing mode) */}
        {isEditing && (
          <Button type="primary" size="small" onClick={onSave} loading={loading}>存檔</Button>
        )}

        {/* Cancel/Revert button (editing mode) */}
        {isEditing && (
          <Button size="small" onClick={onCancel} disabled={loading}>還原</Button>
        )}

        {/* Delete button - always disabled per BR-019 */}
        {!isEditing && hasRecord && (
          <Button danger size="small" disabled>刪除</Button>
        )}
      </Space>
    </div>
  );
};

export default React.memo(ActionBar);
